/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CnTeam.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuCn from "../../assets/component/HomepageMenuCn/HomepageMenuCn.js";

class CnTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="CnTeam-view">
        <Helmet>
          <title>创办人 - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuCn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="CnTeam-first">
          <div className="CnTeam-heading">创办人</div>
        </div>

        <div className="CnTeam-second">
          <div className="CnTeam-centerContainer">
            <div className="CnTeamContainer">
              <div className="CnTeam-edwardPic" />
              <div className="CnTeam-name">
                <strong>赖钧豪 Edward Lai</strong> <br />
                创办人、行政总裁兼首席设计师
              </div>

              <Link to="/CnEdward">
                <div className="CnTeam-learnContainer">
                  <div className="CnTeam-learnTxt">了解更多</div>
                  <div className="CnTeam-learnArrow" />
                </div>
              </Link>
            </div>

            <div className="CnTeamContainer">
              <div className="CnTeam-rixPic" />
              <div className="CnTeam-name">
                <strong>赖钧庭 Rix Lai</strong> <br /> 创办人
              </div>

              <Link to="/CnRix">
                <div className="CnTeam-learnContainer">
                  <div className="CnTeam-learnTxt">了解更多</div>
                  <div className="CnTeam-learnArrow" />
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div className="CnTeam-third">
          <div className="CnTeam-thirdTxt">
            <div className="CnTeam-thirdHeading">我们的故事</div>
            <p />
            我们的两位创办人一直相信，透过科技，我们所有的生活都会变得更加简单。
          </div>
        </div>

        <div className="CnTeam-fourth">
          <div className="CnTeam-fourthTxt">
            有一天，我们的两位创办人坐在咖啡厅讨论香港非牟利机构的网上捐款方法及难处。
          </div>
        </div>

        <div className="CnTeam-fifth">
          <div className="CnTeam-fifthContainer">
            <div className="CnTeam-messageBubble" />

            <div className="CnTeam-fifthTxt">
              当他们跟一些非牟利机构交谈时，他们终于明白了建立和维护网上捐款的成本极高。
            </div>
          </div>
        </div>

        <div className="CnTeam-sixth">
          <div className="CnTeam-sixthContainer">
            <div className="CnTeam-lightBulb" />
            <div className="CnTeam-sixthTxt">
              他们问自己一个问题，
              <p />
              <h4>
                “可以有一个网上捐款管理工具允许捐赠者在不到一分钟的时间内快速捐款？”
              </h4>
            </div>
          </div>
        </div>

        <div className="CnTeam-seventh">
          <div className="CnTeam-seventhContainer">
            <div className="CnTeam-birthdayIcn" />
            <div className="CnTeam-seventhTxt">
              CheckPlus 的诞生就是为了简化非牟利机构的整个捐款程序。
            </div>
          </div>
        </div>

        <div className="CnTeam-eighth">
          <div className="CnTeam-eighthTxt">
            许多人问创办人为什么将他们的公司命名为 CheckPlus。
          </div>
        </div>

        <div className="CnTeam-nineth">
          <div className="CnTeam-checkMark" />

          <div className="CnTeam-ninethTxt">
            <div className="CnTeam-ninethHeading">CheckPlus 是卓越的意思。</div>
            <p />
            每个产品都必须具有出色的设计，同时，所有产品都必须易于使用。
            我们的创办人相信他们在 CheckPlus 所做的一切都采用了相同的思维方式。
          </div>
        </div>

        <div className="CnTeam-tenth">
          <div className="CnTeam-tenthContainer">
            <div className="CnTeam-tenthIcn" />

            <div className="CnTeam-tenthTxt">
              <div className="CnTeam-tenthHeading">我们 Logo 的起源</div>
              <p />
              我们的创办人想要一个简单的 Logo，人们亦很容易识别出含义。
              <p />
              CheckPlus
              是一间科技开发公司。代码是应用程式的沟通方法，而开关引号就是代码的开始和结束。
              <p />
              我们的 Logo 也代表区块链的连系和一条没有尽头流动的河流。
              这意味着与时并进的意思及创造一个更好未来的一份盼望。
            </div>
          </div>
        </div>

        <div className="CnTeam-footer">
          <div className="CnTeam-footerNav">
            <Link to="/CnTeam">
              <div className="CnTeam-footerNavItem">创办人的故事</div>
            </Link>
            <Link to="/CnFaq">
              <div className="CnTeam-footerNavItem">常见问题</div>
            </Link>
            <Link to="/CnContact">
              <div className="CnTeam-footerNavItem">联络我们</div>
            </Link>

            <Link to="/CnPrivacyPolicy">
              <div className="CnTeam-footerNavItem">私隐政策</div>
            </Link>

            <Link to="/CnTerms">
              <div className="CnTeam-footerNavItem">使用条款</div>
            </Link>
          </div>

          <div className="CnTeam-footer_text">
            香港九龙油塘四山街 11 号
            <br />
            华利工业大厦5楼A室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切权利。
          </div>
        </div>
      </div>
    );
  }
}

export default CnTeam;
